import React from 'react';
import { BiLogoNodejs } from 'react-icons/bi';
import { FaCss3, FaHtml5, FaJsSquare, FaPhp } from 'react-icons/fa';
import './style.css'
import { IoLogoCss3 } from 'react-icons/io';
import { DiJqueryLogo } from 'react-icons/di';
import { GrMysql } from 'react-icons/gr';
import { TbReceiptFilled } from 'react-icons/tb';

export const techStackAnimatedIcons  = [ 
   
      { id: 1, name: 'Html', icon:    <FaHtml5 className='text-6xl sm:text-3xl  md:text-4xl lg:text-5xl xl:text-6xl text-center  mx-auto text-[#a0aac7]  icon-html-animate' /> },
      { id: 2, name: 'Css', icon:<IoLogoCss3  className='text-6xl  sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl text-center  mx-auto text-[#a0aac7] icon-css-animate' />
      },
      { id: 3, name: 'Js', icon: <FaJsSquare  className='text-6xl  sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl text-center  mx-auto text-[#a0aac7]  icon-js-animate' />
      },
      { id: 4, name: 'Jquery', icon:<DiJqueryLogo   className='text-6xl sm:text-3xl  md:text-4xl lg:text-5xl xl:text-6xl text-center  mx-auto text-[#a0aac7]  icon-jquery-animate' />
      },
      { id: 5, name: 'Php', icon: <FaPhp   className='text-6xl sm:text-3xl  md:text-4xl lg:text-5xl xl:text-6xl text-center  mx-auto text-[#a0aac7]  icon-php-animate' />
      },
      { id: 6, name: 'Mysql', icon: <GrMysql    className='text-6xl  sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl text-center  mx-auto text-[#a0aac7]  icon-sql-animate' />

      },
    
   
  
   
];

  const  TechStackDesktopAnimation = ({techStackAnimatedIcons}) => {
  return (
      <>
      <div className='hidden sm:flex justify-center '>
   <div className='relative inline-block  '>
  {/* Animated horizontal line */}
  <div className='bg-[#DF73FF] py-1.5  absolute top-[40%] z-[-10]  w-full expand-line-loop'>
    <div className='bg-white py-[2px] '></div>
  </div>
 
  <div className=' space-y-4 sm:space-y-0 sm:space-x-5 md:space-x-7 lg:space-x-10 relative flex flex-row w-12/12'>
    
   

    {
      techStackAnimatedIcons.map((item,index)=>(

     
    <div key={index} className='w-full border-white border-[3px] rounded-xl' style={{ boxShadow: '6px 6px 0 #d4d9e7' }}>
      <div className={`bg-[#e4e9f6] px-5 md:px-6  lg:px-6 xl:px-10 py-6 md:py-7 lg:py-6 xl:py-9 rounded-xl border-2 ${index===0 ?'blink-border-loop':'show-border-loop'} `}>
     {item.icon}
      </div>
    </div>
 ))
}
  </div>
</div>
</div>

      </>
  );
}; 
  const TechStackMobileAnimation = ({techStackAnimatedIcons,width='w-8/12'}) => {
  return (
      <>

      <div className='space-y-4 '>
      <div className=' flex flex-col justify-center w-auto'>
   <div className='relative  inline-block     '>
  {/* Animated horizontal line */}
  {/* <div className='bg-[#DF73FF] px-1  absolute left-[48%] top-[0%] z-[-10]  h-full expand-line-loop-vertical'>
    <div className='bg-white px-[2px] h-full '> </div>
  </div> */}
  <div className='bg-transparent  absolute left-[48%] top-[0%] z-[-10]  h-full expand-line-loop-vertical flex'>
    <div className='bg-[#DF73FF] px-[2px] h-full '> </div>
    <div className='bg-transparent px-[2px] h-full '> </div>
    <div className='bg-[#DF73FF] px-[2px] h-full '> </div>
  </div>

  <div className={` md:space-x-0 space-x-0 space-y-5 relative flex flex-col ${width} max-[425px]:w-8/12 mx-auto `}>
    
    {/* Box 1 */}
    {techStackAnimatedIcons.map((item,index)=>(

  
<div key={index} className='w-full border-white border-[2px] rounded-xl' style={{ boxShadow: '4px 4px 0 #d4d9e7' }}>
  <div className={`bg-[#e4e9f6]  px-4 py-10  rounded-xl border-2 text-center flex items-center w-full  2 ${index===0 ?'blink-border-loop':'show-border-loop'} `}>
{item.icon}      </div>
</div>
))}
  

  
   

  </div>
</div>
</div>
      {/* <div className=' flex justify-center'>
   <div className='relative inline-block mt-2 mb-20  '>
  <div className='bg-[#DF73FF] py-1    absolute top-[50%] z-[-10]  w-full expand-line-loop'>
    <div className='bg-white py-[1px] '></div>
  </div>
 
  <div className=' space-x-7  relative flex flex-row w-12/12'>
    
  

  </div>
</div>
</div> */}
</div>
      </>
  );
};


const  TechStackAnimation = {
  TechStackDesktopAnimation,
  TechStackMobileAnimation
}
export default TechStackAnimation